import React from "react";
import { Layout } from "../../components/layout";
import { Book } from "lucide-react";

export function GettingStartedPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <Book className="h-8 w-8 text-blue-400" />
          <h1 className="text-3xl font-bold text-white">Getting Started</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2>Introduction to Block Pattern Generator</h2>
              <p>
                Block Pattern Generator is a powerful tool that allows you to
                create WordPress block patterns using AI technology. This tool
                simplifies the process of creating complex layouts and designs
                for your WordPress website.
              </p>
            </section>

            <section>
              <h2>Creating Your First Pattern</h2>
              <ol className="space-y-4">
                <li>
                  <strong>Access the Generator:</strong> Navigate to the Block
                  Generator page from the dashboard.
                </li>
                <li>
                  <strong>Describe Your Pattern:</strong> Use natural language
                  to describe the layout you want to create.
                </li>
                <li>
                  <strong>Generate and Customize:</strong> Click "Generate
                  Pattern" and customize the result using the visual editor.
                </li>
                <li>
                  <strong>Save and Export:</strong> Save your pattern to your
                  library or export it directly to WordPress.
                </li>
              </ol>
            </section>

            <section>
              <h2>Understanding the Interface</h2>
              <h3>Main Components:</h3>
              <ul className="space-y-2">
                <li>
                  <strong>Pattern Editor:</strong> Visual interface for creating
                  and editing patterns
                </li>
                <li>
                  <strong>AI Prompt:</strong> Input field for describing your
                  desired pattern
                </li>
                <li>
                  <strong>Preview:</strong> Real-time preview of your pattern
                </li>
                <li>
                  <strong>Code Output:</strong> Generated WordPress block code
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
